import React from 'react';
import SectionHero from './sections/SectionHero';
import SectionSocialProof from './sections/SectionSocialProof';
import SectionPillars from './sections/SectionPillars';
import SectionAbout from './sections/SectionAbout';
import SectionFeatures from './sections/SectionFeatures';
import SectionEE from './sections/SectionEE';
import SectionTestimonials from './sections/SectionTestimonials';
import SectionPricing from './sections/SectionPricing';
import SectionFooter from './sections/SectionFooter';
import BasicBlocks from './blocks/BasicBlocks';

export const SECTION_TYPES = [
  'section_hero','section_social_proof','section_pillars','section_about','section_features','section_ee','section_testimonials','section_pricing','section_footer'
];

export const TEXT_TYPES = [
  'paragraph','heading','list','quote','code','image','gallery','video','button','table','columns','divider','spacer'
];

export function renderBlock(block, props = {}) {
  const { mode = 'view', onChange, selected, onSelect } = props;
  switch (block.type) {
    case 'section_hero': return <SectionHero {...block} mode={mode} onChange={onChange} />;
    case 'section_social_proof': return <SectionSocialProof {...block} mode={mode} onChange={onChange} />;
    case 'section_pillars': return <SectionPillars {...block} mode={mode} onChange={onChange} />;
    case 'section_about': return <SectionAbout {...block} mode={mode} onChange={onChange} />;
    case 'section_features': return <SectionFeatures {...block} mode={mode} onChange={onChange} />;
    case 'section_ee': return <SectionEE {...block} mode={mode} onChange={onChange} />;
    case 'section_testimonials': return <SectionTestimonials {...block} mode={mode} onChange={onChange} />;
    case 'section_pricing': return <SectionPricing {...block} mode={mode} onChange={onChange} />;
    case 'section_footer': return <SectionFooter {...block} mode={mode} onChange={onChange} />;
    default: return <BasicBlocks block={block} mode={mode} onChange={onChange} />;
  }
}

export default function PageRenderer({ blocks = [] }) {
  return (
    <>{blocks.map((b) => <div key={b.block_id || b.type}>{renderBlock(b)}</div>)}</>
  );
}
